<!-- ======= Footer ======= -->
<footer id="footer" class="footer">

    <div class="container-fluid">

        <!--====For 1st Start Div====-->
        <!-- <div class="row">
            <div class="col-5">
                <hr class="vertical_line">
            </div>

            <div class="col-2">
                <div class="text-center footer_head_font">
                    <span style="color:#F37435">XP</span>&nbsp;<span style="color:#0077BD">INDIA</span>
                </div>

            </div>

            <div class="col-5">
                <hr class="vertical_line">
            </div>
        </div> -->
        <!--====For 1st End Div====-->


        <div class="row">

            <div class="col-lg-4 col-md-6">

                <div class="text-center">

                    <!-- <div>
                        <img src="../../../../assets/img/LOGO_XPIndia_Square.png" style="width:60px">
                        <div style="margin-right:40px"><img
                                src="../../../../../assets/img/better_tomorrow_logo-removebg-preview.png"
                                style="width:170px; margin-left: 5%;"></div>


                    </div> -->

                </div>

            </div>

            <div class="col-lg-4 col-md-6 text-center">
                <div class="footer-details">
                    <mat-card-subtitle class="mb-2" style="display: flex;justify-content: center;"><span style="font-weight: 600;">Corporate Address:</span>OCUS Medley Tower, 14th Floor, Sector 99,
                            Gurugram, Haryana 122001</mat-card-subtitle>
                    <mat-card-subtitle style="display: flex;justify-content: center;"><span style="font-weight: 600;">Email:</span>:info@xpindia.in</mat-card-subtitle>
                </div>
            </div>
        </div>

        <div class="footer_head_font text-center mt-1 mobiletext"
            style="font-size: 10px;font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif; color: rgba(0, 0, 0, 0.501);">© Copyright
            XPINDIA. All Rights Reserved</div>
    </div>

</footer>
<!-- End Footer -->